import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import {
  FaChartBar,
  FaFileExcel,
  FaFilePdf,
  FaMoneyBillWave,
  FaWallet,
  FaUserGraduate
} from 'react-icons/fa';

function Reports() {

  const [reports, setReports] = useState([]);

  useEffect(() => {

    axios.get(
      `${process.env.REACT_APP_API_URL}/report`
    )
    .then((res) => {
      setReports(res.data);
    })
    .catch((err) => {
      console.log(err);
    });

  }, []);

  const exportToExcel = () => {

    const worksheet =
      XLSX.utils.json_to_sheet(reports);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Reports'
    );

    const excelBuffer = XLSX.write(
      workbook,
      {
        bookType: 'xlsx',
        type: 'array'
      }
    );

    const data = new Blob(
      [excelBuffer],
      {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    );

    saveAs(data, 'School_Report.xlsx');

  };

  const exportToPDF = () => {

    const doc = new jsPDF();

    doc.setFontSize(18);

    doc.text(
      'School ERP Fee Report',
      14,
      15
    );

    autoTable(doc, {
      startY: 25,
      head: [[
        'Student',
        'Parent',
        'Total Fee',
        'Paid Fee',
        'Pending Fee'
      ]],
      body: reports.map(item => [
        item.student_name,
        item.parent_name,
        item.total_fee,
        item.paid_fee,
        item.pending_fee
      ])
    });

    doc.save(
      'School_Report.pdf'
    );

  };

  const totalStudents =
    reports.length;

  const totalCollected =
    reports.reduce(
      (sum, item) =>
        sum +
        Number(item.paid_fee || 0),
      0
    );

  const totalPending =
    reports.reduce(
      (sum, item) =>
        sum +
        Number(item.pending_fee || 0),
      0
    );

  return (

    <Layout>

      <div className="container-fluid">

        <div className="mb-4">

          <h1
            style={{
              fontWeight: '800',
              color: '#0f172a'
            }}
          >
            Reports & Analytics
          </h1>

          <p
            style={{
              color: '#64748b'
            }}
          >
            School financial reports and insights
          </p>

        </div>

        {/* SUMMARY CARDS */}

        <div className="row mb-4">

          <div className="col-md-4">

            <div
              className="card p-4"
              style={{
                borderRadius: '24px',
                background:
                  'linear-gradient(135deg,#6366f1,#8b5cf6)',
                color: '#fff'
              }}
            >

              <FaUserGraduate
                size={40}
              />

              <h5 className="mt-3">
                Students
              </h5>

              <h2>
                {totalStudents}
              </h2>

            </div>

          </div>

          <div className="col-md-4">

            <div
              className="card p-4"
              style={{
                borderRadius: '24px',
                background:
                  'linear-gradient(135deg,#10b981,#22c55e)',
                color: '#fff'
              }}
            >

              <FaMoneyBillWave
                size={40}
              />

              <h5 className="mt-3">
                Total Collection
              </h5>

              <h2>
                ₹{totalCollected}
              </h2>

            </div>

          </div>

          <div className="col-md-4">

            <div
              className="card p-4"
              style={{
                borderRadius: '24px',
                background:
                  'linear-gradient(135deg,#ef4444,#f87171)',
                color: '#fff'
              }}
            >

              <FaWallet
                size={40}
              />

              <h5 className="mt-3">
                Pending Amount
              </h5>

              <h2>
                ₹{totalPending}
              </h2>

            </div>

          </div>

        </div>

        {/* REPORT TABLE */}

        <div
          className="card p-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <div className="d-flex justify-content-between align-items-center mb-4">

            <h4>
              <FaChartBar />
              {' '}
              Reports
            </h4>

            <div>

              <button
                className="btn btn-success me-2"
                onClick={
                  exportToExcel
                }
              >
                <FaFileExcel />
                {' '}
                Export Excel
              </button>

              <button
                className="btn btn-danger"
                onClick={
                  exportToPDF
                }
              >
                <FaFilePdf />
                {' '}
                Export PDF
              </button>

            </div>

          </div>

          <div className="table-responsive">

            <table className="table">

              <thead>

                <tr
                  style={{
                    background:
                      '#eef2ff'
                  }}
                >

                  <th>Student</th>
                  <th>Parent</th>
                  <th>Total Fee</th>
                  <th>Paid Fee</th>
                  <th>Pending Fee</th>
                  <th>Status</th>

                </tr>

              </thead>

              <tbody>

                {reports.map(
                  (
                    item,
                    index
                  ) => (

                    <tr
                      key={index}
                    >

                      <td>
                        {
                          item.student_name
                        }
                      </td>

                      <td>
                        {
                          item.parent_name
                        }
                      </td>

                      <td>
                        ₹
                        {
                          item.total_fee
                        }
                      </td>

                      <td>
                        ₹
                        {
                          item.paid_fee
                        }
                      </td>

                      <td>
                        ₹
                        {
                          item.pending_fee
                        }
                      </td>

                      <td>

                        {Number(
                          item.pending_fee
                        ) === 0 ? (

                          <span className="badge bg-success">
                            Paid
                          </span>

                        ) : (

                          <span className="badge bg-danger">
                            Pending
                          </span>

                        )}

                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </Layout>

  );

}

export default Reports;